var moduleMap = {
	"./Classes": () => {
		return __webpack_require__.e(/* __federation_expose_Classes */ 7108).then(() => (() => ((__webpack_require__(7064)))));
	},
	"./AllPupilsComponent": () => {
		return __webpack_require__.e(/* __federation_expose_AllPupilsComponent */ 647).then(() => (() => ((__webpack_require__(1447)))));
	},
	"./ArchiveClassesComponent": () => {
		return __webpack_require__.e(/* __federation_expose_ArchiveClassesComponent */ 2047).then(() => (() => ((__webpack_require__(6085)))));
	},
	"./ClassViewComponent": () => {
		return __webpack_require__.e(/* __federation_expose_ClassViewComponent */ 3772).then(() => (() => ((__webpack_require__(1382)))));
	},
	"./TeachersComponent": () => {
		return __webpack_require__.e(/* __federation_expose_TeachersComponent */ 4278).then(() => (() => ((__webpack_require__(7301)))));
	},
	"./StatisticsComponent": () => {
		return __webpack_require__.e(/* __federation_expose_StatisticsComponent */ 7666).then(() => (() => ((__webpack_require__(4326)))));
	},
	"./ClassStatisticsComponent": () => {
		return __webpack_require__.e(/* __federation_expose_ClassStatisticsComponent */ 7978).then(() => (() => ((__webpack_require__(136)))));
	},
	"./TeacherStartPageComponent": () => {
		return __webpack_require__.e(/* __federation_expose_TeacherStartPageComponent */ 6784).then(() => (() => ((__webpack_require__(8996)))));
	},
	"./TeacherLessonsComponent": () => {
		return __webpack_require__.e(/* __federation_expose_TeacherLessonsComponent */ 6442).then(() => (() => ((__webpack_require__(7958)))));
	},
	"./Login": () => {
		return __webpack_require__.e(/* __federation_expose_Login */ 6167).then(() => (() => ((__webpack_require__(6169)))));
	},
	"./Registration": () => {
		return __webpack_require__.e(/* __federation_expose_Registration */ 8259).then(() => (() => ((__webpack_require__(8271)))));
	},
	"./AppRemoteComponent": () => {
		return __webpack_require__.e(/* __federation_expose_AppRemoteComponent */ 3892).then(() => (() => ((__webpack_require__(9330)))));
	},
	"./AppRemoteRoutes": () => {
		return __webpack_require__.e(/* __federation_expose_AppRemoteRoutes */ 8825).then(() => (() => ((__webpack_require__(8703)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};

__webpack_require__(940)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});